<script>
    import { createEventDispatcher } from 'svelte';
    import { onMount } from 'svelte';
    
    export let opciones = ''
    
    let hide = null

    const dispatch = createEventDispatcher()
    
    onMount (async () => { 
    })
    
    const _click_opcion = (name) => {
        dispatch('_click_opcion',{opcion : name})
    }

    const _toggleMenu = () => {
        hide = hide === "hide" ? "" : "hide"
    }
    
</script>

<div class="main-menuflotante  ">
    <div class="opc" on:click={_toggleMenu}>
        <div>
            <ion-icon id="opc-x" name="ellipsis-vertical-outline"></ion-icon>
        </div>
    </div>
    {#each opciones as item, i}
         <div class="opc" style="display:{hide || !item.show ? "none" : "flex"}" on:click={_click_opcion(item.name)} title={item.desc} >
            <div style="background-color: {item.backgroundColor};" title={item.desc}>
                <ion-icon id="opc-{i}" name="{item.icon}" title={item.name}></ion-icon>
            </div>
        </div>
    {/each}
</div>

    
<style>
    .main-menuflotante {
        z-index: 999;
        display: flex;
        flex-direction: column;
        position: fixed;
        right : 0px;
        bottom: 0px;
        color: #fff;
        margin: 8px;
        overflow: hidden;
        padding: 10px;
        transition: height 500ms , justify-content 300ms;
        justify-content: center;
    }

    ion-icon  {
        font-size: 1.5em;
        pointer-events: none;
    }
    
    .opc {
        font-size: 0.8em;
        display: flex;
        flex-direction: row;
        transition: display 1000ms;
    }

    .opc > div {
        /* border: 2px solid #fff; */
        background-color: tomato;
        border-radius : 50%;
        width: 4em;
        height: 4em;
        justify-content: center;
        align-items: center;
        display: flex;
        margin-bottom: 0.5em;
        box-shadow: 2px 2px 7px 0px #7b7676;
        cursor: pointer;
        transition: background-color 250ms;
    }

    .opc>div:hover {
        background-color: #fff !important;
        color: tomato !important;
    }


</style>